import { createUuid } from '~/_shared/utils/createUuid';
import type { DemographicIdCode } from '~/store/boundaryGroups/boundaryGroups.repository';
import type { DemographicRegion } from '~/store/demographics/demographics.types';
import type {
  DataLayer, DataLayerId,
} from './mapSettingsDataLayers.state';

export const createDataLayerId = (): DataLayerId => createUuid();

export const createDataLayer = ({
  id, title, region, demographics,
}: {
  title: string;
  region: DemographicRegion;
  demographics: ReadonlyArray<DemographicIdCode>;
} & Partial<DataLayer>): DataLayer => ({
  id: id || createDataLayerId(),
  data: {
    title,
    region,
    demographics: demographics || [],
  },
});
